var _ellipse, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharacter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 113,
    viewBox: "0 0 118 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7943,
    cy: 56.6223,
    rx: 52.9786,
    ry: 61.1204,
    transform: "rotate(-125.496 58.7943 56.6223)",
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.2825 91.0001C75.3502 91.0001 87.565 88.2176 87.565 84.7852C87.565 81.3528 75.3502 78.5703 60.2825 78.5703C45.2148 78.5703 33 81.3528 33 84.7852C33 88.2176 45.2148 91.0001 60.2825 91.0001Z",
    fill: "#212A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.472 73.3116L73.9448 83.6884L64.4283 67.9404H51.7584L50.9771 68.6434L46.972 73.178C46.972 73.178 55.5242 79.8077 48.788 87.1193L34.6541 73.6631L40.3203 67.9404H36.6108V41.2881C36.6108 35.7727 38.8045 30.4832 42.7091 26.5832C46.6138 22.6832 51.9097 20.4922 57.4317 20.4922C62.9538 20.4922 68.2496 22.6832 72.1543 26.5832C76.059 30.4832 78.2526 35.7727 78.2526 41.2881L78.1681 67.9052H74.2334L76.514 71.6454C76.514 71.6454 85.031 64.9946 90.472 73.3116Z",
    fill: "#1C48C9",
    stroke: "white",
    strokeWidth: 1.51,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7738 42.5113C64.5007 42.5113 65.09 41.4914 65.09 40.2334C65.09 38.9754 64.5007 37.9556 63.7738 37.9556C63.0468 37.9556 62.4575 38.9754 62.4575 40.2334C62.4575 41.4914 63.0468 42.5113 63.7738 42.5113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0384 42.5113C70.7654 42.5113 71.3547 41.4914 71.3547 40.2334C71.3547 38.9754 70.7654 37.9556 70.0384 37.9556C69.3115 37.9556 68.7222 38.9754 68.7222 40.2334C68.7222 41.4914 69.3115 42.5113 70.0384 42.5113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4722 46.1182C61.4722 46.1182 66.6176 51.5245 72.4246 46.1182",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 71,
    fill: "white",
    transform: "translate(33 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/character.7590e9cd4d1c758f6a56415147b748f4.svg";
export { ForwardRef as ReactComponent };